import { render, staticRenderFns } from "./EventDialog.vue?vue&type=template&id=4b042ffe&scoped=true"
import script from "./EventDialog.vue?vue&type=script&lang=js"
export * from "./EventDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b042ffe",
  null
  
)

export default component.exports